/** Angular Modules Import */

import moment from "moment";
// Manually import necessary locales
import "moment/locale/de";
import "moment/locale/en-gb";

import {registerLocaleData} from "@angular/common";
import localeDe from "@angular/common/locales/de";
import {MatTooltipDefaultOptions} from "@angular/material/tooltip";

registerLocaleData(localeDe, "de");

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
	showDelay: 0,
	hideDelay: 0,
	touchendHideDelay: 1500,
	disableTooltipInteractivity: true,
};

moment.fn.toJSON = function () {
	return this.format("YYYY-MM-DD");
};
